import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-camp-care-booking-calendar-body',
    templateUrl: './camp-care-booking-calendar-body.component.html',
    styleUrls: ['./camp-care-booking-calendar-body.component.scss'],
    standalone: false
})
export class CampCareBookingCalendarBodyComponent implements OnInit {

    @Input()
    public calendarData: camps.CampCareBookingCalendarData;

    constructor() { }

    ngOnInit() {
    }

}
